<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/d3lzu0/tc-custom/9781685507107.jpg?1723404942190" alt="This image is the cover for the book Third Time Lucky"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Third Time Lucky
      </h1>
      <p class="bookDescription body article font2">
        <p>Neither Troy Nakamura nor Laszlo Jovanovic expect anything after their one-night stand. Troy is bound for college and Laszlo is heading to graduate school on the other side of the continent.<br/><br/>They don’t see each other again for five years, when Troy’s former competition dance partner invites him to her wedding, where he can’t resist another encounter with Laszlo. Then he says more than he should. While Laszlo lets him down easy, the fact is Troy’s still in law school and the other man’s work is taking him to Europe. Their first parting wasn’t easy, but this one really hurts.<br/><br/>As Laszlo winds up his final European contract seven years later, a traumatic incident disrupts his intention to stay with his parents for a while. Troy, now living near their families again, offers a place to live while Laszlo sorts himself out.<br/><br/>Both of them had always thought what if. With privacy, peace, and the opportunity to learn just how they’ve both changed since that first momentous night, is the time finally right for love?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Alexandra Caluen
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?203fc4fe